import { Component } from '@angular/core';
import {DataBagService} from "./data-bag.service";
import {Footer} from "./models";


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'webapp';

  constructor(private dataBag: DataBagService) {
  }

  get footerValue() : Footer {
    return <Footer>this.dataBag.footer;
  }
}
